<app-section [sectionConfig]="sectionConfig"></app-section>
